import React, { useEffect, useState } from "react";
import { atom, useRecoilState } from "recoil";
import dayjs from "dayjs";
import LineBox from "../../components/DefaultStyles/LineBox";
import PageTitle from "../../components/DefaultStyles/PageTitle";
import DropDown, { OptionType } from "../../components/Filters/DropDown";
import Search from "../../components/Filters/Search";
import Pagination from "../../components/Table/Pagination";
import Table, { TableBody, TableBodyItem } from "../../components/Table/Table";
import { useApi } from "../../hooks/useApi";
import { Filters, TotalCount } from "./UserInfo";
import ExcelDownload from "../../components/DefaultStyles/ExcelDownload";
import { GetStringByKey } from "../../Api/ApiTranslate";
import LineBtn from "../../components/Button/LineBtn";
import {
  ManageLogTableDetailContainer,
  ManageLogTableDetailContent,
} from "../Manage/ManageLog";
import Loader from "../../components/DefaultStyles/Loader";
import SpaceBetween from "../../components/DefaultStyles/SpaceBetween";
import { getThousandComma } from "../../Api/ApiCommon";
import ReJoinModal from "./ExitUserInfo/ReJoinModal";
import { useNavigate } from "react-router-dom";
import { getEllipsis } from "../../ApiTS/ApiCommonTS";

interface IExitUserInfo {
  uid: string;
  name: string;
  birthday: string;
  reason: string;
  reasondetail: string;
  exitdate: string;
  indate: string;
  reRegister: number;
}

export const exitUserInfoPageState = atom<number>({
  key: "exitUserInfoPageState",
  default: 0,
});

export default function ExitUserInfo() {
  const navigate = useNavigate();
  const [savedPage, setSavedPage] = useRecoilState<number>(exitUserInfoPageState);

  const [page, setPage] = useState(savedPage);

  useEffect(() => {
    setSavedPage(page);
  }, [page]);
  const [searchValue, setSearchValue] = useState<string | undefined>("");
  const [dropDownValue, setDropDownValue] = useState<OptionType>({
    value: "",
    label: "선택",
  });
  const [detail, setDetail] = useState(false);
  const [activeIndex, setActiveIndex] = useState<number | null>(null);
  const [reJoinModal, setRejoinModal] = useState({
    user: "",
    modal: false,
  });

  const { response, loading, fetchData } = useApi({
    method: "get",
    url:
      searchValue !== ""
        ? `user/exit?page=${page}&size=10&${dropDownValue?.value}=${searchValue}`
        : `user/exit?page=${page}&size=10`,
  });

  console.log(response);

  const tableHead = [
    "NO",
    "UID",
    "이름",
    "생년월일",
    "탈퇴 사유",
    "내용",
    "탈퇴일",
    "가입 일시",
    "상세",
    "재가입 허용",
  ];

  useEffect(() => {
    if (searchValue !== "") {
      setPage(0);
    }
  }, [searchValue]);

  useEffect(() => {
    setTimeout(() => {
      setDetail(false);
    }, 100);
  }, [page]);

  return (
    <>
      <PageTitle title="탈퇴 회원 정보" />

      <Filters>
        <DropDown
          isDisabled={false}
          setDropDownValue={setDropDownValue}
          dropdownValue={dropDownValue}
        />

        <Search
          placeholder="입력"
          setSearchValue={setSearchValue}
          isDisabled={dropDownValue ? false : true}
          pageResetEvent={() => setPage(0)}
          inputType={
            dropDownValue?.value === "phone" || dropDownValue?.value === "uid"
              ? "number"
              : undefined
          }
        />
      </Filters>

      <LineBox>
        <Table tableHeadData={tableHead} tableMinWidth={1180}>
          <>
            {response?.data?.items?.map((d: IExitUserInfo, index: number) => {
              return (
                <React.Fragment key={index}>
                  <TableBody>
                    <TableBodyItem>
                      {response?.data?.totalCount - (page * 10 + index)}
                    </TableBodyItem>
                    <TableBodyItem
                      clickable={true}
                      onClick={() => {
                        setSavedPage(page);
                        navigate(`/users/info/${d?.uid}`);
                      }}
                    >
                      {d?.uid}
                    </TableBodyItem>
                    <TableBodyItem>{d?.name}</TableBodyItem>
                    <TableBodyItem>{d?.birthday}</TableBodyItem>
                    <TableBodyItem>
                      {d?.reason?.split("_")[0]}_
                      {GetStringByKey(Number(d?.reason?.split("_")[1]))}
                    </TableBodyItem>
                    <TableBodyItem>
                      {getEllipsis(d?.reasondetail, 18)}
                    </TableBodyItem>
                    <TableBodyItem>
                      {dayjs(d?.exitdate)?.format("YYYY-MM-DD")}
                    </TableBodyItem>
                    <TableBodyItem>
                      {dayjs(d?.indate)?.format("YYYY-MM-DD HH:mm")}
                    </TableBodyItem>
                    <TableBodyItem>
                      <LineBtn
                        btnText={
                          activeIndex === index && detail ? "접기" : "상세"
                        }
                        disabled={d?.reasondetail === ""}
                        btnClickEvent={() => {
                          setActiveIndex(index);

                          if (activeIndex === index) {
                            // 열려있을 때
                            setDetail(!detail);
                          } else {
                            // 열기
                            setDetail(true);
                          }
                        }}
                      />
                    </TableBodyItem>
                    <TableBodyItem>
                      <LineBtn
                        btnText="재가입"
                        disabled={d?.reRegister === 1}
                        btnClickEvent={() =>
                          setRejoinModal({
                            modal: true,
                            user: `${d?.uid}_${d?.name}`,
                          })
                        }
                      />
                    </TableBodyItem>
                  </TableBody>

                  {activeIndex === index && detail && (
                    <ManageLogTableDetailContainer>
                      <ManageLogTableDetailContent colSpan={10}>
                        {d?.reasondetail}
                      </ManageLogTableDetailContent>
                    </ManageLogTableDetailContainer>
                  )}
                </React.Fragment>
              );
            })}
          </>
        </Table>

        <SpaceBetween>
          <Pagination
            totalPage={response?.status === 200 ? response.data.totalPage : 1}
            currentPage={page}
            pageClickEvent={(index) => setPage(index)}
          />

          <TotalCount>
            총{" "}
            {getThousandComma(
              response?.status === 200 ? +response?.data?.totalCount : 0
            )}
            개
          </TotalCount>
        </SpaceBetween>
      </LineBox>

      <ExcelDownload
        disabled={response?.data?.items?.length < 1}
        tableHead={tableHead?.slice(1, tableHead?.length)}
        pushedData={(e: any) => {
          return [
            e.uid,
            e.name,
            e.birthday,
            e.phone,
            `${e?.reason?.split("_")[0]}_
                    ${GetStringByKey(Number(e?.reason?.split("_")[1]))}`,
            e?.reasondetail,
            dayjs(e?.exitdate)?.format("YYYY-MM-DD"),
            dayjs(e?.indate)?.format("YYYY-MM-DD HH:mm"),
          ];
        }}
        dataUrl={
          searchValue !== ""
            ? `user/exit?page=0&size=1000&${dropDownValue?.value}=${searchValue}`
            : `user/exit?page=0&size=1000`
        }
      />

      {loading && <Loader />}

      {reJoinModal.modal && (
        <ReJoinModal
          closeEvent={() =>
            setRejoinModal({
              modal: false,
              user: "",
            })
          }
          confirmEvent={() =>
            fetchData({
              method: "get",
              url:
                searchValue !== ""
                  ? `user/exit?page=${page}&size=10&${dropDownValue?.value}=${searchValue}`
                  : `user/exit?page=${page}&size=10`,
            })
          }
          user={reJoinModal.user}
        />
      )}
    </>
  );
}
